module.exports = __webpack_public_path__ + "static/media/logo_techcombank.6921d1f9.svg";